import classNames from 'classnames';

import lang from '../../../lib/language';
import { ReferralSummary } from '../../../lib/models/crm/types';

import copyIcon from '../../../assets/img/copy-icon.svg';
import { GlobalClassesEnum } from '../../../assets/scss/globalClasses/globalClasses.constants';
import { buildReferralShareUrl } from '../../../containers/Referrals/helpers';
import { useCopiedToast } from '../../../hooks';
import Toast from '../../Toast/Toast';

import styles from './ReferralPromoBanner.module.scss';

type Props = {
  summary: ReferralSummary;
  onShare: () => void;
  isAwaitingActivation?: boolean;
};

const secondaryClasses = classNames(GlobalClassesEnum.CommonBody2Text, GlobalClassesEnum.CommonTextSecondary);

const ReferralPromoBanner = ({ summary, onShare, isAwaitingActivation = false }: Props) => {
  const { code, link, registrations, purchases } = summary;
  const { isCopied, copyToClipboard } = useCopiedToast();

  const codeLabel = isAwaitingActivation ? lang.referralsPendingAccountTitle() : lang.referralsYourCode();
  const codeValue = isAwaitingActivation ? lang.referralsPendingAccountCode() : code;
  const linkLabel = isAwaitingActivation ? lang.referralsPendingShareYourLink() : lang.referralsShareYourLink();

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.codeBlock}>
          <div className={GlobalClassesEnum.CommonBody1Text}>{codeLabel}</div>
          <div className={GlobalClassesEnum.CommonH1Bold}>{codeValue}</div>
        </div>

        <div className={styles.linkBlock}>
          <div className={secondaryClasses}>{linkLabel}</div>
          <div className={styles.linkRow}>
            <div className={styles.linkField}>
              {isAwaitingActivation ? (
                <div className={classNames(secondaryClasses, styles.link)}>
                  {lang.referralsPendingLinkPlaceholder()}
                </div>
              ) : (
                <>
                  <div className={classNames(GlobalClassesEnum.CommonBody2Text, styles.link)}>{link}</div>
                  <button
                    type="button"
                    className={styles.copyButton}
                    onClick={() => copyToClipboard(buildReferralShareUrl(link))}
                    aria-label={lang.referralsCopyLink()}
                  >
                    <img src={copyIcon} alt="" />
                  </button>
                </>
              )}
            </div>
            {!isAwaitingActivation && (
              <button type="button" className={styles.shareButton} onClick={onShare}>
                {lang.referralsShare()}
              </button>
            )}
          </div>
        </div>

        <div className={styles.summaryRows}>
          <div className={styles.summaryRow}>
            <div className={secondaryClasses}>{lang.referralsRegistrations()}</div>
            <div className={GlobalClassesEnum.CommonBody2TextBold}>{registrations}</div>
          </div>
          <div className={styles.summaryRow}>
            <div className={secondaryClasses}>{lang.referralsPurchases()}</div>
            <div className={GlobalClassesEnum.CommonBody2TextBold}>{purchases}</div>
          </div>
        </div>
      </div>

      <Toast isOpen={isCopied} message={lang.copiedToClipboard()} />
    </div>
  );
};

export default ReferralPromoBanner;
